export default function HealthBar({ curr, max, className, dir = 'horiz' }) {
    const fill = (curr / max) * 100

    return <div className={`healthBar ${className} ${dir}`}>
        <div className="healthBarMax">
            <div className="healthBarCurr" style={ dir === 'horiz' ? { width: `${fill}%` } : { height: `${fill}%` }}>
            </div>
        </div>
    </div>
}